// FRB Program Variables
export const frbVariables: any = {
    programTitle: "First Republic Bank",
    effectiveDates: "7/1/2022 - 7/1/2023",
    faqUrl: "https://bit.ly/GEXL_FAQs_APC",
    supportEmail: "groupexcessliability@alliant.com",
    feeDisclaimer: false,
    EL_Items: [
        "21127",
        ["21128", "$1,000,000", "$557"],
        ["21129", "$2,000,000", "$757"],
        ["21130", "$3,000,000", "$840"],
        ["21131", "$5,000,000", "$1,225"],
        ["21132", "$10,000,000*", "$2,187"],
        ["21133", "$15,000,000**", "$3,351"],
        ["21134", "$20,000,000**", "$6,668"],
        ["21135", "$25,000,000**", "$8,513"],
        ["21136", "$50,000,000**", "$25,007"]
    ],
    EL_Disclaimers: [
        "<strong>*</strong>The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb.",
        `<strong>**</strong>It is a requirement that any participant who <u>newly elects or enrolls</u> at these limits have their underlying home and auto insurance policies in place with Chubb and complete the Group Personal Excess Participants Questionnaire.  These limits are subject to prior underwriting approval.  These requirements have been waived for current participants renewing at their expiring limit.`
    ],
    UM_Items: [
        "21137",
        ["21138", "$1,000,000", "Included above"],
        ["21139", "$2,000,000", "$117"],
        ["21140", "$3,000,000", "$236"],
        ["21141", "$5,000,000", "$470"]
    ],
    EPLI_Items: [
        "21142",
        ["21143", "By selecting this box, I am declining EPLI insurance."],
        ["21144", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$789"],
        ["21145", "$500,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,183"]
    ],
    CI_Items: [
        "21146",
        "21147",
        "21148"
    ],
    learnMoreUrl: "https://bit.ly/GEXL_PIReview_APC"
};

